import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective, ResponsiveService } from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-partners-split-landing',
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, StarRatingModule, MatIcon],
})
export class PartnersSectionComponent extends BaseSectionComponent {
  constructor(public override responsiveService: ResponsiveService) {
    super(responsiveService);
  }
}
